import React from 'react'
import PropTypes from 'prop-types'
import { Card, Row, Col, Statistic, Spin } from 'antd'
import { CheckCircleOutlined, ClockCircleOutlined, WarningOutlined, FileTextOutlined } from '@ant-design/icons'
import './Component.css'

export default class _StatsBar_ extends React.PureComponent {

  static propTypes = {
    dashboard: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
  }

  render () {

    var { dashboard, loading } = this.props

    if (loading) {
      return (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <Spin />
        </div>
      )
    }

    return (
      <div className="rams-stats-bar">
        <Row gutter={16}>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <Card>
              <Statistic
                title="Active RAMS Records"
                value={dashboard.active_rams_records || 0}
                prefix={<FileTextOutlined />}
              />
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <Card>
              <Statistic
                title="Completion Rate"
                value={dashboard.completion_rate || 0}
                suffix="%"
                prefix={<CheckCircleOutlined />}
                valueStyle={{ color: (dashboard.completion_rate || 0) >= 80 ? '#3f8600' : '#cf1322' }}
              />
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <Card>
              <Statistic
                title="Pending Signatures"
                value={dashboard.total_pending || 0}
                prefix={<ClockCircleOutlined />}
                valueStyle={{ color: '#1890ff' }}
              />
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6} lg={6} xl={6}>
            <Card>
              <Statistic
                title="Overdue"
                value={dashboard.overdue_count || 0}
                prefix={<WarningOutlined />}
                valueStyle={{ color: (dashboard.overdue_count || 0) > 0 ? '#cf1322' : '#3f8600' }}
              />
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}
